module.exports = __webpack_public_path__ + "static/img/1.b2a8747.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/1.png
// module id = 2/9f
// module chunks = 0